var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { t } from '../../../../strings/i18n/i18n';
import styled from 'styled-components';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
var CancelConfirmationText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  font-weight: ", ";\n  text-align: center;\n  font-size: ", "px;\n"], ["\n  display: flex;\n  justify-content: center;\n  font-weight: ", ";\n  text-align: center;\n  font-size: ", "px;\n"])), fontWeights.bold, fontSizes.medium);
var CancelConfirmationContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var ImageContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"])), spacing.xxlarge, spacing.large);
var AdditionalInfoCancelConfirmation = function () {
    var assetsURL = useSelector(function (state) { return state; }).mfeConfig.assetsURL;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'small' : 'medium';
    return (_jsxs(CancelConfirmationContainer, __assign({ "data-cy": "additional-info-cancel-confirmation" }, { children: [_jsx(ImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "WARNING", size: imageSize }) }), _jsx(CancelConfirmationText, { children: t('additionalInfo.cancelConfirmation') })] })));
};
export default AdditionalInfoCancelConfirmation;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map